<template>
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="106"
    height="55"
    viewBox="0 0 106 55"
    fill="none"
  >
    <mask
      id="mask0_2645_56623"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="106"
      height="55"
    >
      <rect
        x="-0.5"
        y="0.5"
        width="104"
        height="53.7826"
        transform="matrix(-1 0 0 1 104.5 0)"
        fill="#C4C4C4"
        stroke="#27AE60"
      />
    </mask>
    <g mask="url(#mask0_2645_56623)">
      <path
        opacity="0.2"
        d="M88.3207 27.6988C96.8167 27.4281 104.896 40.1428 107.082 45.4446V55.0938H-5.68488L-1.80131 13.2287C6.82883 15.5632 16.0343 10.8942 18.6659 10.778C24.6006 10.778 33.4506 24.0889 37.4071 31.0827C40.6556 37.3095 44.7994 38.6406 46.4653 38.5278C54.2117 38.7985 60.1048 24.8785 62.083 17.8847C63.8322 10.0334 65.8014 8.40918 66.7683 8.40919C68.3905 8.40413 70.8289 10.7104 73.3277 18.5616C75.8265 26.4127 79.783 28.6011 81.4489 28.7139C83.779 28.8717 86.5507 27.6988 88.3207 27.6988Z"
        fill="url(#paint0_linear_2645_56623)"
      />
      <path
        d="M107.082 45.4446C104.896 40.1428 96.8167 27.4281 88.3207 27.6988C86.5507 27.6988 83.779 28.8717 81.4489 28.7139C79.783 28.6011 75.8265 26.4127 73.3277 18.5616C70.8289 10.7104 68.3905 8.40413 66.7683 8.40919C65.8015 8.40918 63.8322 10.0334 62.083 17.8847C60.1048 24.8786 54.2117 38.7985 46.4653 38.5278C44.7995 38.6406 40.6556 37.3095 37.4071 31.0827C33.4506 24.0889 24.6006 10.778 18.6659 10.778C16.0343 10.8942 6.82885 15.5632 -1.80129 13.2287"
        stroke="#09B78A"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <mask id="path-5-inside-1_2645_56623" fill="white">
        <ellipse
          cx="1.43835"
          cy="1.55632"
          rx="1.43835"
          ry="1.55632"
          transform="matrix(-1 0 0 1 28.4041 14.6294)"
        />
      </mask>
      <ellipse
        cx="1.43835"
        cy="1.55632"
        rx="1.43835"
        ry="1.55632"
        transform="matrix(-1 0 0 1 28.4041 14.6294)"
        fill="white"
      />
      <path
        d="M27.5273 16.1857C27.5273 16.1134 27.4994 16.0174 27.4174 15.9288C27.333 15.8374 27.1743 15.742 26.9657 15.742V19.742C24.9212 19.742 23.5273 17.9985 23.5273 16.1857H27.5273ZM26.9657 15.742C26.7571 15.742 26.5984 15.8374 26.514 15.9288C26.432 16.0174 26.4041 16.1134 26.4041 16.1857H30.4041C30.4041 17.9985 29.0102 19.742 26.9657 19.742V15.742ZM26.4041 16.1857C26.4041 16.2581 26.432 16.354 26.514 16.4427C26.5984 16.534 26.7571 16.6294 26.9657 16.6294V12.6294C29.0102 12.6294 30.4041 14.373 30.4041 16.1857H26.4041ZM26.9657 16.6294C27.1743 16.6294 27.333 16.534 27.4174 16.4427C27.4994 16.354 27.5273 16.2581 27.5273 16.1857H23.5273C23.5273 14.373 24.9212 12.6294 26.9657 12.6294V16.6294Z"
        fill="#09B78A"
        mask="url(#path-5-inside-1_2645_56623)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2645_56623"
        x1="50.6987"
        y1="8.40918"
        x2="50.8671"
        y2="55.0937"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4ECDC4" />
        <stop offset="1" stop-color="#4ECDC4" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>